import { render, staticRenderFns } from "./GradeCourses.vue?vue&type=template&id=15dbbf96"
import script from "./GradeCourses.vue?vue&type=script&lang=js"
export * from "./GradeCourses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports